<template>
  <div>
    <div v-if="showLastRiskEvaluation">
      <h4>Evaluación de riesgo</h4>
      <risk-answers-view
        :snapshot="riskEvaluationData.snapshot"
        :answers="riskEvaluationData.answersRaw"
      />
    </div>
  </div>
</template>

<script>
import { computed,ref, onMounted } from "@vue/composition-api";
import RiskAnswersView from "@/components/BuildRiskForm/RiskAnswersView.vue";

export default {
  props: {
    branch: {
      type: Object
    }
  },
  components: {
    RiskAnswersView
  },
  setup (props) {
    //HOOKS
    onMounted(() => buildData());

    //DATA
    const riskEvaluationData = ref({
      answersRaw: null,
      snapshot: null,
    });

    //COMPUTED
    const showLastRiskEvaluation = computed(() => (riskEvaluationData.value.answersRaw && riskEvaluationData.value.snapshot));

    //METHODS
    const buildData = () => {
      const { form_answers = [] } = props.branch.last_risk_evaluation;
        if (form_answers.length) {
          const [formAnswerData] = form_answers;
          const formData = getFormData(formAnswerData);

          riskEvaluationData.value.answersRaw = formData.data || null;
          riskEvaluationData.value.snapshot = formData.template_snapshot || null;
        }
    }

    const getFormData = (dataForm) => {
      let template = {};

      if (dataForm.template) {
        template = {
          ...dataForm.template,
          data: dataForm.template.data.filter((d) => d.options.alarms),
        };
      }

      const formData = {
        ...dataForm,
        template,
      };

      return formData;
    }

    return {
      riskEvaluationData,

      showLastRiskEvaluation
    }
  }
}
</script>
